
import { createContext, useState } from "react";


const MarketingContext = createContext();

export default MarketingContext;

export const MarketingProvider = ((props) => {

   
    //ROULETTE START

    const [drawnumbers_low, setDrawNumbersLow] = useState([])
    const [drawnumbers_middle, setDrawNumbersMiddle] = useState([])
    const [drawnumbers_high, setDrawNumbersHigh] = useState([])

    const [playnumbers_low, setPlayNumbersLow] = useState([1, 2, 3, 4, 5,6,7,8,9,10,11,12])
    const [playnumbers_middle, setPlayNumbersMiddle] = useState([13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24])
    const [playnumbers_high, setPlayNumbersHigh] = useState([25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36])

    const[displayroulette, setDisplayRoulette] = useState(false)

    const onPlayNumber = (group, number) => {

        console.log("Group, number:", group, number)

        let numbers = []
        
        if (group === 'low')
        {
            numbers = [...playnumbers_low]
             //remove number from the group
            const index = numbers.indexOf(number);
            if (index > -1) 
            {

                //remove from play
                numbers.splice(index, 1);
                setPlayNumbersLow(numbers)

                //add to draw
                let arr = [...drawnumbers_low]
                // Add the number
                arr.push(number);
    
                // Sort in ascending order
                 arr.sort((a, b) => a - b);
                 setDrawNumbersLow(arr)


            }
        }
         else if (group === 'middle')

        {
            numbers = [...playnumbers_middle]
            //remove number from the group
            const index = numbers.indexOf(number);
            if (index > -1) 
            {
                numbers.splice(index, 1);
                setPlayNumbersMiddle(numbers)

                 //add to draw
                let arr = [...drawnumbers_middle]
                // Add the number
                arr.push(number);
    
                // Sort in ascending order
                 arr.sort((a, b) => a - b);
                 setDrawNumbersMiddle(arr)
            }
        }    
        else if (group === 'high')
        {
            numbers = [...playnumbers_high]
            //remove number from the group
            const index = numbers.indexOf(number);
            if (index > -1) 
            {
                numbers.splice(index, 1);
                setPlayNumbersHigh(numbers)

                 //add to draw
                let arr = [...drawnumbers_high]
                // Add the number
                arr.push(number);
    
                // Sort in ascending order
                 arr.sort((a, b) => a - b);
                 setDrawNumbersHigh(arr)
            }
        }
        else {
            console.log("OnPlayNumber: invalid number group.")
        }
       
       
    }

  const onDrawNumber = (group, number) => {

        console.log("onDrawNumber: Group, number:", group, number)

        let numbers = []
        
        if (group === 'low')
        {
            numbers = [...drawnumbers_low]
             //remove number from the group
            const index = numbers.indexOf(number);
            if (index > -1) 
            {

                //remove from draw
                numbers.splice(index, 1);
                setDrawNumbersLow(numbers)

                //add to play
                let arr = [...playnumbers_low]
                // Add the number
                arr.push(number);
    
                // Sort in ascending order
                 arr.sort((a, b) => a - b);
                 setPlayNumbersLow(arr)
            }
        }
         else if (group === 'middle')
        {
             numbers = [...drawnumbers_middle]
             //remove number from the group
            const index = numbers.indexOf(number);
            if (index > -1) 
            {

                //remove from draw
                numbers.splice(index, 1);
                setDrawNumbersMiddle(numbers)

                //add to play
                let arr = [...playnumbers_middle]
                // Add the number
                arr.push(number);
    
                // Sort in ascending order
                 arr.sort((a, b) => a - b);
                 setPlayNumbersMiddle(arr)
            }
        
        }    
        else if (group === 'high')
        {
            numbers = [...drawnumbers_high]
             //remove number from the group
            const index = numbers.indexOf(number);
            if (index > -1) 
            {

                //remove from draw
                numbers.splice(index, 1);
                setDrawNumbersHigh(numbers)

                //add to play
                let arr = [...playnumbers_high]
                // Add the number
                arr.push(number);
    
                // Sort in ascending order
                 arr.sort((a, b) => a - b);
                 setPlayNumbersHigh(arr)
            }
        }
        else {
            console.log("OnDrawNumber: invalid number group.")
        }
       
    }

    const onDisplayRoulette = () => {
        setDisplayRoulette(!displayroulette)
    }

    //ROULETTE END


    return <MarketingContext.Provider value={{
   
        //Roulette
        drawnumbers_low,
        drawnumbers_middle,
        drawnumbers_high,

        playnumbers_low,
        playnumbers_middle,
        playnumbers_high,

        onPlayNumber,
        onDrawNumber,

        displayroulette,
        onDisplayRoulette
       
    }}>
        {props.children}
    </MarketingContext.Provider>
})

